import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Calendar as CalendarIcon } from "lucide-react";
import { format, parse, isValid } from "date-fns";
import { it } from "date-fns/locale";
import { cn } from "../lib/utils";

/**
 * Date picker that produces ISO strings (YYYY-MM-DD) and accepts the same format.
 * Italian locale, italian-style display dd/MM/yyyy in the trigger.
 * Header shows clean month/year dropdowns + prev/next arrows.
 */
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const DatePicker = ({
    value,
    onChange,
    placeholder = "Seleziona data",
    fromYear = 1940,
    toYear = new Date().getFullYear() + 5,
    defaultMonth,
    disabled,
    "data-testid": testId,
}) => {
    const date = value
        ? (() => {
              const d = parse(value, "yyyy-MM-dd", new Date());
              return isValid(d) ? d : undefined;
          })()
        : undefined;

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    type="button"
                    variant="outline"
                    disabled={disabled}
                    data-testid={testId}
                    className={cn(
                        "h-10 w-full justify-start gap-2 font-normal",
                        !date && "text-slate-400"
                    )}
                >
                    <CalendarIcon className="h-4 w-4 text-slate-500" />
                    {date ? format(date, "dd/MM/yyyy", { locale: it }) : placeholder}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    mode="single"
                    selected={date}
                    onSelect={(d) => {
                        if (d) onChange(format(d, "yyyy-MM-dd"));
                    }}
                    locale={it}
                    captionLayout="dropdown-buttons"
                    fromYear={fromYear}
                    toYear={toYear}
                    defaultMonth={date || defaultMonth || new Date()}
                    formatters={{
                        formatMonthCaption: (m) => capitalize(format(m, "LLLL", { locale: it })),
                    }}
                    initialFocus
                />
            </PopoverContent>
        </Popover>
    );
};
